import React, { Component } from 'react';
import Lightbox from 'react-images';

export default class Gallery extends Component {

  state = {
    currentImage: this.props.currentImage,
    lightboxIsOpen: this.props.lightboxIsOpen || false,
    images: this.props.images || []
  };

  closeLightbox(){
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    });
    typeof this.props.onClose !== "undefined" ? this.props.onClose() : '';
  }

  gotoPrevious () {
    this.setState({
     currentImage: this.state.currentImage - 1,
    });
    typeof this.props.onClickPrev !== "undefined" ? this.props.onClickPrev() : '';
  }

  gotoNext () {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
    typeof this.props.onClickNext !== "undefined" ? this.props.onClickNext() : '';
  }

  gotoImage (index) {
    this.setState({
      currentImage: index,
    });
  }

  render() {
    const { images, currentImage, lightboxIsOpen } = this.state;
    
    return(
      <Lightbox
        images={this.props.images || images}
        currentImage={this.props.currentImage || currentImage}
        isOpen={this.props.lightboxIsOpen}
        onClose={::this.closeLightbox}
        onClickNext={::this.gotoNext}
        onClickPrev={::this.gotoPrevious}
        backdropClosesModal={this.props.backdropClosesModal || true}
        showThumbnails={this.props.showThumbnails || false}
        onClickThumbnail={::this.gotoImage}
        zoom={this.props.showThumbnails || true}
        customMedia={this.props.customMedia || null}
      />
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/common/gallery.js